export const WEISCHER_MAIN = 'main'
export const WEISCHER_PREROLL = 'preroll'
export const WEISCHER_OVERVIEW = 'overview'
export const WEISCHER_OVERVIEW_HERO = 'overview_hero'
export const WEISCHER_INTERSCROLLER = 'interscroller'